export const DASHBOARD_LAYOUT_CONTENT_ID = "dashboardLayoutContent";
